<template>
  <div>

    <v-card-title>
      <h2>Loan Profile</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.loan_no }}</td>        
        <td class="text-xs-left">{{ props.item.re_schedule_no }}</td>
        <td class="text-xs-left">{{ props.item.reset_no }}</td>
        <td class="text-xs-left">{{ props.item.sub_project_name }}</td>
        <td class="text-xs-left">{{ props.item.loan_amount }}</td>
        <td class="text-xs-left">{{ props.item.transaction_currency }}</td>
        <!-- <td class="text-xs-left">{{ props.item.short_name }}</td>
        <td class="text-xs-left">{{ props.item.client_name }}</td>
        <td class="text-xs-left">{{ props.item.sector_name }}</td> -->

        <td class="justify-center layout px-0">
          <v-btn title="Edit" icon class="mx-0" @click="editItem(props.index, props.item)">
            Repayment
          </v-btn>

          <v-btn title="Edit" icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn title="Delete" icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
  
        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import Axios from "axios";

export default {
  data: () => ({

    /*############# Datatable #############*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      {
        text: "Loan Number",
        align: "left",
        sortable: true,
        value: "loan_no"
      },
      {
        text: "Re Schedule No",
        align: "left",
        sortable: true,
        value: "re_schedule_no"
      },
      {
        text: "Reset No",
        align: "left",
        sortable: true,
        value: "reset_no"
      },
      {
        text: "Sub Project Name",
        align: "left",
        sortable: true,
        value: "sub_project_name"
      },
      {
        text: "Loan Amount",
        align: "left",
        sortable: true,
        value: "loan_amount"
      }, 
      {
        text: "Transaction Currency",
        align: "left",
        sortable: true,
        value: "transaction_currency"
      }, 
     
      { text: "Action", align: "center", value: "" }
    ]
    /*############# /Datatable #############*/
  }),

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {          
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },

  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "loan-profile-list")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    
    close() {
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/lending/loanProfile/repayment.vue